export default __webpack_public_path__ + "static/media/situation-coref-create-situation-2.c5b032fb.gif";